import { useTranslation } from "react-i18next";
import Popup, {
  PopupActions,
  PopupButton,
  PopupContent,
  PopupHeading,
} from "../../../../../components/Common/Popup";
import React from "react";
import { usePortal } from "../../../../../Providers/PortalProvider";
import { useAuth } from "../../../../providers/AuthProvider";

const ExpiredTermsOfServiceDialog = (props) => {
  const { t } = useTranslation();
  const { terms } = usePortal();
  const { logout, acceptTermsOfService } = useAuth();

  return (
    <Popup onClose={props.onClose}>
      <PopupHeading>{t("Updated terms of service")}</PopupHeading>
      <PopupContent>
        <p>
          {terms.termsOfService.split(/\n/).map((line) => (
            <>
              {line}
              <br />
            </>
          ))}
        </p>
      </PopupContent>

      <PopupActions>
        <PopupButton fullWidth onClick={() => logout()} secondary>
          {t("Log out")}
        </PopupButton>
        <PopupButton fullWidth onClick={() => acceptTermsOfService()}>
          {t("Accept terms")}
        </PopupButton>
      </PopupActions>
    </Popup>
  );
};

export default ExpiredTermsOfServiceDialog;
